import { TemplateResult, LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import encapsulatedStyles from './styles/outline-callout-bar-block.encapsulated.css?inline';
import globalStyles from './styles/outline-callout-bar-block.global.css?inline';
import '../outline-container/outline-container';

const componentName = 'outline-callout-bar-block';

/**
 * Outline Callout Bar Block component
 * 
 * @slot heading - The heading of the callout bar 
 * @slot content - The content of the callout bar
 * @slot cta - The call to action button
 */

@customElement('outline-callout-bar-block')
export class OutlineCalloutBarBlock extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
      encapsulatedCSS: encapsulatedStyles,
      globalCSS: globalStyles,
  });

    render(): TemplateResult {
        return html`
        <div class="callout-bar">
            <outline-container
                container-width="full-bleed"
                background-color="gradient-gold">
                <div class="callout-bar-container">
                    <div class="callout-bar-content">
                        <slot name="heading"></slot>
                        <slot name="content"></slot>
                    </div>
                    <div class="callout-bar-cta">
                        <slot name="cta"></slot>
                    </div>
                </div>
            </outline-container>
        </div>
        
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [componentName]: OutlineCalloutBarBlock;
    }
}